import React, { Fragment, useRef, useState } from 'react';
import Option from '../Option';
import './style.css';
import LabelWithOption from '../LabelWithOption';

const Accordion = ({
  title,
  id,
  disabled,
  headerOptions,
  children,
  bodyOptions,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentEl = useRef();

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className='accordion'>
      <div
        className={`accordion-header ${isExpanded ? 'expanded' : ''}`}
        onClick={toggleAccordion}
      >
        <div className='accordion-control-label'>
          <div className='title'>{title.replaceAll('-', ' ')}</div>
          {headerOptions && (
            <Fragment>
              <span className='title-dash'>-</span>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Option
                  disabled={disabled}
                  type='header'
                  id={id}
                  options={headerOptions}
                />
              </div>
            </Fragment>
          )}
        </div>
        <span
          class={`material-symbols-outlined cursor-pointer arrow-icon ${
            isExpanded ? 'expanded' : ''
          }`}
        >
          expand_more
        </span>
      </div>
      {isExpanded && (
        <div
          className={`accordion-content ${
            isExpanded ? 'height-full' : 'height-none'
          }`}
          ref={contentEl}
        >
          {bodyOptions && (
            <LabelWithOption
              disabled={disabled}
              id={id}
              options={bodyOptions}
            />
          )}
          {children}
        </div>
      )}
    </div>
  );
};
export default Accordion;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/Accordion/index.jsx